<div class="card borderGrow ">
  <div class="flex items-center justify-between my-5 how-comment">
    <ng-container *ngIf="boxData && boxData.length > 0">
      <div boxBorderBottomItem [class]=" 'col-lg-' + colNumber " *ngFor="let item of boxData" class="col-12"
        [iconSource]="item.iconSource" [title]="item.title" [description]="item.description"></div>
    </ng-container>
  </div>
</div>
